module.exports = __webpack_public_path__ + "static/media/1361_MessageEducation_read_HL.58c1cdd2.png";